import React from "react";
import { ArrowUpRight } from "lucide-react";
import Reveal, { Eyebrow } from "../common/Reveal";
import { blog } from "../../mock";

export default function Blog() {
  const [feature, ...rest] = blog.posts;
  return (
    <section id="blog" className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-xl">
            <Reveal><Eyebrow color="blue">{blog.eyebrow}</Eyebrow></Reveal>
            <Reveal delay={80}><h2 className="mt-4 font-serif text-4xl lg:text-5xl text-lybl-ink">{blog.title}</h2></Reveal>
            <Reveal delay={140}><p className="mt-4 text-lybl-muted text-lg">{blog.subtitle}</p></Reveal>
          </div>
          <Reveal delay={160}>
            <a href="#" className="inline-flex items-center gap-2 rounded-full border border-lybl-green/30 px-5 py-2.5 text-[14px] font-medium text-lybl-green hover:bg-lybl-green hover:text-white transition-colors">View All</a>
          </Reveal>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-2">
          <Reveal>
            <a href="#" className="group block overflow-hidden rounded-3xl ring-1 ring-black/5 h-full hover:shadow-xl transition-shadow">
              <div className="h-72 lg:h-[22rem] overflow-hidden">
                <img src={feature.image} alt={feature.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-7">
                <span className="text-[12px] font-semibold uppercase tracking-wider text-lybl-rust">{feature.tag}</span>
                <h3 className="mt-2 font-serif text-2xl text-lybl-ink leading-snug">{feature.title}</h3>
                <p className="mt-3 text-[13px] text-lybl-muted">{feature.date} · By {feature.author}</p>
              </div>
            </a>
          </Reveal>

          <div className="grid gap-6">
            {rest.map((p, i) => (
              <Reveal key={p.title} delay={i * 70}>
                <a href="#" className="group flex gap-5 rounded-3xl ring-1 ring-black/5 p-4 hover:shadow-lg transition-shadow">
                  <div className="h-28 w-32 shrink-0 overflow-hidden rounded-2xl">
                    <img src={p.image} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="flex-1">
                    <span className="text-[11px] font-semibold uppercase tracking-wider text-lybl-rust">{p.tag}</span>
                    <h3 className="mt-1 font-serif text-lg text-lybl-ink leading-snug">{p.title}</h3>
                    <p className="mt-2 text-[12px] text-lybl-muted">{p.date} · {p.author}</p>
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-lybl-muted group-hover:text-lybl-green transition-colors shrink-0" />
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
